module.exports = __webpack_public_path__ + "static/media/syafiqah-editorial.64a97912.png";